module.exports = __webpack_public_path__ + "img/jazz-festival-footnotes.dd6e6174.jpeg";